import { urlConstants } from 'common/utils/constants';
import { secureApi } from 'api/Axios';

export const userListService = () => {
  return secureApi
    .get(`${urlConstants.getInvestorUsers}`)
    .then((res) => res)
    .catch((err) => Promise.reject(err));
};

export const inviteUserService = (payload: any) => {
  return secureApi
    .post(`${urlConstants.inviteInvestorUser}`, payload)
    .then((res) => res)
    .catch((err) => Promise.reject(err));
};

export const updateUserService = (id: string, payload: any) => {
  return secureApi
    .patch(`${urlConstants.updateInvestorUser}/${id}`, payload)
    .then((res) => res)
    .catch((err) => Promise.reject(err));
};

export const deleteUserService = (id: string) => {
  return secureApi
    .delete(`${urlConstants.deleteInvestorUser}/${id}`)
    .then((res) => res)
    .catch((err) => Promise.reject(err));
};
